import axios from 'axios';
import {requestAuth, toParam} from './helper';

const {REACT_API_HOST} = process.env;
const {REACT_API_HOST2} = process.env;
const {REACT_APP_STRIPE_PK} = process.env;
const {REACT_APP_LOCATIONIQ_TOKEN} = process.env;

const loginEmail = async (params) => {
    const url = REACT_API_HOST + '/login';

    const {email, pass} = params;

    const body = {
        'email': email,
        'password': pass,
        'registration_source': 'email'
    };

    const data = await axios.post(url, body);

    return {
        ...data
    };

};

const loginSoc = async (params) => {
    const url = REACT_API_HOST + '/authorize_social_via_access_token' + toParam(params);
    const data = await axios.get(url, params);
    return data;
};

const loginViaGoogle = async (params) => {
    const url = REACT_API_HOST + '/authorize_social_via_access_token';
    const data = await axios.post(url, params);
    return data;
};


const getUserInfo = async (token) => {
    const url = REACT_API_HOST + '/user/self';
    const config = requestAuth(token);
    const data = await axios.get(url, config);
    return data.data;
};

const setAllUsersGeoInfo = async (token) => {
    const url = REACT_API_HOST + '/circles/all-users-geo-info';
    const config = requestAuth(token);
    const data = await axios.get(url, config);
    return data.data;
};

const getCirclesInfo = async (token) => {
    const url = REACT_API_HOST + '/circles';
    const config = requestAuth(token);
    const data = await axios.get(url, config);
    return data.data;
};

const getDevicesInfo = async (token) => {
    const url = REACT_API_HOST + '/circles/devices';
    const config = requestAuth(token);
    const data = await axios.get(url, config);
    return data.data;
};

const getAllInvites = async (token) => {
    const url = REACT_API_HOST + '/invites';
    const config = requestAuth(token);
    const data = await axios.get(url, config);
    return data.data;
};

const logoutUser = async (token) => {
    const url = REACT_API_HOST + '/user/logout';
    const config = requestAuth(token);
    const data = await axios.get(url, config);
    return data.data;
};

const subscribeRequest = async (token, IDs) => {
    const params = {
        'user_ids': IDs
    };
    const url = REACT_API_HOST + '/live-location/subscribe';
    const config = requestAuth(token);
    return await axios.post(url, params, config);
};

const unsubscribeRequest = async (token, IDs) => {
    const params = {
        'user_ids': IDs
    };

    const url = REACT_API_HOST + '/live-location/unsubscribe';
    const config = requestAuth(token);
    return await axios.post(url, params, config);
};

export const getReversedGeoCode = async (lat, lng) => {
    const url = `https://eu1.locationiq.com/v1/reverse.php?key=${REACT_APP_LOCATIONIQ_TOKEN}&lat=${lat}&lon=${lng}&format=json`;
    const data = await axios.get(url);

    const address = data.data.address.road ?
        `${data.data.address.road}, ${data.data.address.house_number || data.data.address.neighbourhood || ''}`
        : (data.data.address.suburb || data.data.address.state);
    return address;
};

export const getGeoCode = async (value) => {
    const url = `https://eu1.locationiq.com/v1/search.php?key=${REACT_APP_LOCATIONIQ_TOKEN}&q=${value}&format=json`;
    const data = await axios.get(url);

    const {
        lat,
        lon
    } = data.data[0];

    return {
        lat,
        lon
    };
};

export const getLocationByIP = async () => {
    const url = REACT_API_HOST2 + '/cf-country';
    const data = await axios.get(url);

    return data.data.country_code;
};

const resetPassword = async (params) => {
    const url = REACT_API_HOST2 + '/restore_password';

    const body = {
        'email': params
    };
    const {data: {data}} = await axios.post(url, body);
    return {
        ...data,
    };
};


export const purchaseWithStripe = async (params) => {
    const {plan, paymentMethodNonce, token, AFUserID} = params;

    const url = `${REACT_API_HOST2}/users/me/subscriptions/${plan}`;

    const config = requestAuth(token);

    const body = {
        'gateway': 'stripe',
        'payment_method_nonce': paymentMethodNonce,
        'coupon': '',
        'appsflyer_id': AFUserID
    };

    return await axios.post(url, body, config);
};

export const getInviteLinkForPhone = async (params) => {
    const {token, circleID, phone} = params;
    const url = REACT_API_HOST + '/invites/create-for-phone';
    const config = requestAuth(token);


    const body = {
        'circle_id': circleID,
        'phone_number': phone
    };

    return await axios.post(url, body, config);
};


export const getInviteLink = async (params) => {
    const {token, circleID} = params;
    const url = REACT_API_HOST + '/invites/create-invite-link';
    const config = requestAuth(token);


    const body = {
        'circle_id': circleID,
    };

    return await axios.post(url, body, config);
};

export const sendInviteToUser = async (params) => {
    const {token, circleID, userID} = params;
    const url = REACT_API_HOST + '/invites/create-to-user';
    const config = requestAuth(token);


    const body = {
        'circle_id': circleID,
        'recipient_id': userID,
    };

    return await axios.post(url, body, config);
};

export const getPaymentSettings = async (token) => {
    const url = REACT_API_HOST2 + '/users/me/payments-settings';
    const config = requestAuth(token);
    const data = await axios.get(url, config);
    const defaultData = {
        stripe_account_name: 'Geozilla 1',
        stripe_publishable_key: REACT_APP_STRIPE_PK,
    };
    return data.data || defaultData;
};

export const getDeeplinkData = async (token) => {
    const url = REACT_API_HOST2 + '/users/me/deeplink-qr-code';
    const config = requestAuth(token);
    const data = await axios.get(url, config);
    return data.data;
};


export default {
    loginEmail,
    loginSoc,
    loginViaGoogle,
    getUserInfo,
    setAllUsersGeoInfo,
    getCirclesInfo,
    logoutUser,
    subscribeRequest,
    unsubscribeRequest,
    getReversedGeoCode,
    getLocationByIP,
    getGeoCode,
    resetPassword,
    purchaseWithStripe,
    getInviteLinkForPhone,
    getInviteLink,
    sendInviteToUser,
    getAllInvites,
    getDevicesInfo,
    getPaymentSettings,
    getDeeplinkData,
};